import _ from 'lodash';
import moment from 'moment';

// this file includes utility functions for tracked hour

// calculates the total tracked hour over the list of entities
export function getTotalTrackedHour(
  entities?: Array<{computeHours: number}>
): moment.Duration | undefined {
  if (entities == null) {
    return undefined;
  }

  const trackedHourInSeconds = _.sumBy(entities, 'computeHours');

  return moment.duration(trackedHourInSeconds, 'seconds');
}
